import React, {Component} from 'react'
import {Card} from '../Card'
import {Title} from '../Title'

import './grid.css'

const desktopWidth = 720;
const defaultMargin = 33;
const mobilePadding = 21;

class Grid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: desktopWidth,
    }

    this.updateWidth = this.updateWidth.bind(this);
  }

  componentDidMount() {
    this.updateWidth();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.updateWidth);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateWidth);
    }
  }

  updateWidth() {
    if (typeof window !== 'undefined') {
      this.setState({width: window.innerWidth < desktopWidth ? window.innerWidth - 2 * mobilePadding: desktopWidth});
    }
  }

  renderRows(array, nCellsPerRow, marginTop, marginLeft) {
    let chunks = this.chunkByRows(array, nCellsPerRow);
    return (
      chunks.map(
        (chunk, index) =>
          <div key={index} className="row" style={{marginTop : index == 0 ? 0 : marginTop}}>
              {this.renderRow(chunk, nCellsPerRow, marginLeft)}
          </div>
      )
    );
  }

  chunkByRows(array, nCellsPerRow) {
    var chunkedArray = [];
    var len = array.length;
    for (let i = 0; i < len; i += nCellsPerRow) {
      chunkedArray.push(array.slice(i, i + nCellsPerRow));
    }

    return chunkedArray;
  }

  computeCellWidth(totalWidth, nCells, marginLeft) {
    return (totalWidth - (nCells - 1) * marginLeft) / nCells;
  }

  renderRow(row, nCellsPerRow, marginLeft) {
    let width = this.computeCellWidth(this.state.width, nCellsPerRow, marginLeft);
    let cells = row.map(
      function(cell, index) {
        let margin = index === 0 ? 0 : marginLeft;
        return (
          <div key={index} style={{width : width, marginLeft: margin}} className="cell">
            {cell}
          </div>
        );
      }
    );

    return (
      <div> {cells} </div>
    );
  }

  render() {
    let marginLeft = this.props.marginLeft ? this.props.marginLeft : defaultMargin;
    let marginTop = this.props.marginTop ? this.props.marginTop : marginLeft;
    let nCellsPerRow = this.state.width < desktopWidth ? this.props.nCellsPerRowMobile : this.props.nCellsPerRow;
    let rows = this.renderRows(this.props.data, nCellsPerRow, marginTop, marginLeft);

    return (
      <div>
        {rows}
      </div>
    );
  }
}

export default {Grid}



// WEBPACK FOOTER //
// ./src/components/Grid/index.js